import React from "react";
import { useLang } from "@/i18n/LanguageContext";

const DEST_IMG =
  "https://images.unsplash.com/photo-1750967613664-9541fb33b766?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtYXlhbiUyMHJ1aW5zJTIwdHVsdW0lMjBjaGljaGVuJTIwaXR6YXxlbnwwfHx8fDE3ODE3MjI4MTh8MA&ixlib=rb-4.1.0&q=85";

const places = [
  "Cancún Hotel Zone",
  "Playa del Carmen",
  "Tulum",
  "Akumal",
  "Puerto Morelos",
  "Isla Mujeres",
  "Chichén Itzá",
  "Xcaret",
  "Cobá",
  "Bacalar",
  "Holbox",
  "Valladolid",
];

const Destinations = () => {
  const { t } = useLang();

  return (
    <section
      id="destinations"
      data-testid="destinations-section"
      className="py-24 sm:py-32 bg-[#EAE6DF]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start">
          <div className="relative aspect-[4/5] overflow-hidden">
            <img
              src={DEST_IMG}
              alt="Mayan ruins"
              className="w-full h-full object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#1A1F24] to-transparent p-8 text-white">
              <p className="font-serif text-3xl">Chichén Itzá</p>
              <p className="text-sm text-white/80 mt-1">A wonder of the ancient world</p>
            </div>
          </div>

          <div className="lg:pt-16">
            <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-4">
              {t.destinations.eyebrow}
            </p>
            <h2 className="font-serif text-4xl sm:text-5xl text-[#1A1F24] tracking-tight mb-8">
              {t.destinations.title}
            </h2>

            <div className="flex flex-wrap gap-2 mt-8">
              {places.map((p) => (
                <span
                  key={p}
                  data-testid={`destination-tag-${p}`}
                  className="bg-white/70 border border-[#1A1F24]/10 px-4 py-2 text-sm text-[#1A1F24] tracking-wide transition-all hover:bg-[#1A1F24] hover:text-white cursor-default"
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Destinations;
